import {mapMutations} from 'vuex';
import {
    SHOW_CATALOG_MENU,
} from '@/store/mutation-types';
export default {
    name: 'catalog-list',
    props: ['list'],
    data() {
        return {
            positionScroll: 0,
        }
    },
    methods: {
        ...mapMutations({
            changeShowCatalogMenu: `system/${SHOW_CATALOG_MENU}`
        }),
        changeScrollCatalogList(){
            this.$nextTick(() => {
                this.$refs.headerCatalog.scrollTop = this.positionScroll += 74;
            });
        },
        scrollCatalogHeader(event){
            this.positionScroll = event.target.scrollTop;
        }
    }
}
